import { useCallback, useContext } from 'react';
import {
  useActionItem,
  ActionItemOperation as Operation,
  AiContext,
} from '@workboard/action-item';

export function useConvertToSubAction(aiId: string, onUpdate: () => void) {
  const { setDisabledEnforceFocus } = useContext(AiContext);
  const { isPermitted, actionItem, refetch } = useActionItem(aiId);
  const workstreamId = actionItem?.workstreamContext?.workstream?.id;
  const canConvertToSubAction = isPermitted(Operation.convertToSubaction);
  const aiType = actionItem?.typeAttributes?.id ?? 0;
  const convertToSubAction = useCallback(() => {
    setDisabledEnforceFocus(true);
    const handleUpdate = async () => {
      setDisabledEnforceFocus(false);
      onUpdate();
      await refetch();
    };
    window.convertToSubaction(
      aiId,
      workstreamId,
      null,
      handleUpdate,
      true,
      aiType
    );
  }, [aiId, workstreamId, onUpdate, setDisabledEnforceFocus, refetch, aiType]);

  return [canConvertToSubAction, convertToSubAction] as const;
}
